import { color } from '@scp/ui-shared/theme/variables';
export var APP_BAR_COLOR_BY_THEME = {
  practice: color.brandPractice,
  connect: color.brandConnect,
  care: color.brandCare,
  portal: color.brandPortal,
  admin: color.brandAdmin,
  patient: color.brandPatient
};
export var APP_BAR_TEXT_COLOR_BY_THEME = {
  practice: color.palette.white,
  connect: color.palette.white,
  care: color.palette.white,
  portal: color.palette.white,
  admin: color.palette.white,
  patient: color.palette.black
};
export var APP_BAR_RIPPLE_COLOR_BY_THEME = {
  practice: color.rippleOnDark,
  connect: color.rippleOnDark,
  care: color.rippleOnDark,
  portal: color.rippleOnDark,
  admin: color.rippleOnDark,
  patient: color.ripple
};
export var APP_BAR_SECTION_COLOR_BY_THEME = {
  practice: color.palette.grey800,
  connect: color.palette.grey800,
  care: color.palette.grey800,
  portal: color.palette.grey800,
  admin: color.palette.grey800,
  patient: color.palette.grey400
};